import React, { memo, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import './css/CoachThumbnail1.css';
import { isValidString } from '../../../../../catalog/Validity';
import { getProfileImage, getProfileObjectFit } from '../../../../../catalog/Website';
import { context } from '../../../../../globalState/GlobalState';

const CoachThumbnail1 = (props) => {
    const { coach } = props;
    const { globalState } = useContext(context);

    const getCoachInfo = (details, infoTitle) => {
        let info = '';
        details.forEach((detail) => {
            if (detail.title === infoTitle) {
                info = detail.value;
            }
        });
        return info;
    };

    return (
        <NavLink key={coach.id} className="coach-thumbnail1-container curve-border-20px text-black text-no-underline m-t-20px m-b-20px p-t-5px p-b-5px p-l-50px p-r-10px" to={`/coaches/${coach.id}`}>
            <div className="coach-thumbnail1-main-info-container">
                <img className="coach-thumbnail1-image curve-border-10px" src={getProfileImage(globalState, coach.profileImage)} alt={isValidString(coach.name) ? coach.name : 'Coach Profile Image'} style={{ objectFit: getProfileObjectFit(globalState, coach.profileImage) }} />
                <div className="coach-thumbnail1-name-container m-l-30px m-r-30px">
                    <p className="coach-thumbnail1-subname alegreya-font-family font-weight-800 text-left-align m-t-0 m-b-0 text-uppercase font-size-l">{getCoachInfo(coach.details, 'Title')}</p>
                    <p className="coach-thumbnail1-name alegreya-font-family font-weight-800 text-left-align m-t-0 m-b-0 text-uppercase font-size-3xl">{coach.name}</p>
                    {/* <p className="coach-thumbnail1-subname-black alegreya-font-family font-weight-800 text-left-align m-t-0 m-b-0 text-uppercase font-size-l">{getCoachInfo(coach.details, 'Hometown')}</p> */}
                </div>
                <p className="coach-thumbnail1-year m-t-0 m-b-0 m-l-30px text-center-align text-capitalize font-size-l">{getCoachInfo(coach.details, 'Year')}</p>
            </div>
            <div className="coach-thumbnail1-side-info-container">
                <div className="coach-thumbnail1-side-info">
                    {isValidString(getCoachInfo(coach.details, 'Hometown')) ? (<p className="coach-thumbnail1-side-info-text text-right-align m-t-5px m-b-5px m-r-10px text-uppercase font-size-l">{getCoachInfo(coach.details, 'Hometown')}</p>) : null}
                    {/* {isValidString(getCoachInfo(coach.details, 'Born')) ? (<p className="coach-thumbnail1-side-info-text text-right-align m-t-5px m-b-5px m-r-10px text-uppercase font-size-l">{`Born: ${getCoachInfo(coach.details, 'Born')}`}</p>) : null} */}
                </div>
                <KeyboardArrowRightIcon className="coach-thumbnail1-side-info-arrow" />
            </div>
        </NavLink>
    );
};

CoachThumbnail1.propTypes = {
    coach: PropTypes.object.isRequired,
};

export default memo(CoachThumbnail1);
